// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Login from './modules/Login/Login';
import CompanySelectionPage from './components/CompanySelectionPage';
import ProtectedRoute from './components/ProtectedRoute';
import MenuDrawer from './modules/Menu/Menu';
import AccesoDenegado from './utils/AccesoDenegado'; 
import PermisoWrapper from './utils/PermisoWrapper';

import { Items } from './modules/Menu/Items';

const theme = createTheme({
  typography: {
    fontFamily: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 12,
    htmlFontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    body1: { fontFamily: "'Geist', 'Inter', sans-serif", fontSize: 'clamp(0.68rem, 0.66rem + 0.10vw, 0.82rem)' },
    body2: { fontFamily: "'Geist', 'Inter', sans-serif", fontSize: 'clamp(0.62rem, 0.60rem + 0.10vw, 0.76rem)' },
    caption: { fontFamily: "'Geist', 'Inter', sans-serif", fontSize: 'clamp(0.56rem, 0.54rem + 0.08vw, 0.68rem)' },
    button: { fontFamily: "'Geist', 'Inter', sans-serif", textTransform: 'none', fontSize: 'clamp(0.62rem, 0.60rem + 0.10vw, 0.76rem)' },
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        root: {
          fontFamily: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          padding: '4px 8px',
          lineHeight: 1.2,
        },
        sizeSmall: {
          padding: '2px 6px',
        },
        sizeMedium: {
          padding: '4px 8px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          textTransform: 'none',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontFamily: "'Geist', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<Login />} />

          {/* Layout general protegido con sesión y empresa */}
          <Route element={<ProtectedRoute><MenuDrawer /></ProtectedRoute>}>
            <Route path="/company-selection" element={<CompanySelectionPage />} />

            {/* Página de acceso denegado DENTRO del layout */}
            <Route path="/acceso-denegado" element={<AccesoDenegado />} />

            {/* Rutas protegidas por permiso */}
            {Items.map(({ id, permisoId, path, component: Component }) => (
              <Route
                key={path}
                path={path}
                element={
                  <ProtectedRoute permisoId={permisoId ?? id}>
                    <PermisoWrapper permisoId={permisoId ?? id}>
                      <Component />
                    </PermisoWrapper>
                  </ProtectedRoute>
                }
              />
            ))}
          </Route>
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
